import React, { useEffect } from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";

import { Toast } from "./components/CommonComponents/Toast/Toast";
import NetworkStatusBanner from "./components/CommonComponents/NetworkBanner/NetworkStatusBanner";
import DialogProvider from "./components/CommonComponents/Dialog/DialogProvider";
import AppRoutes from "./AppRoutes";
import { useLogger } from "./utils/UnifiedLogger";
import { resetAppChatState } from "./utils/appReset/resetAppChatState";
import { useDispatch } from "react-redux";
import { useAppContext } from "./context/AppContext";

const App = () => {
  const dispatch = useDispatch();
  const { sharedApiService, setSelectedLanguageData } = useAppContext();

  useEffect(() => {
    resetAppChatState({ dispatch, sharedApiService, setSelectedLanguageData });
  }, []);

  return (
    <>
      <DialogProvider>
        <Toast>
          <NetworkStatusBanner />

          <Router>
            <AppRoutesWrapper />
          </Router>
        </Toast>
      </DialogProvider>
    </>
  );
};

const AppRoutesWrapper = () => {
  const { pathname, search } = useLocation();
  const { logInfo } = useLogger("Routes", false);

  useEffect(() => {
    logInfo("ROUTE_CHANGED", `${pathname}${search}`);
  }, [pathname, search]);

  const urlParams = new URLSearchParams(search);
  const hasPayload = urlParams.has("payload");

  return <AppRoutes hasPayload={hasPayload} />;
};

export default App;
